import React from "react";
import { useSelector } from "react-redux";
import useSessionTimeout from "../hooks/useSessionTimeout";
import SessionTimeoutModal from "./SessionTimeoutModal";

/**
 * SessionTimeoutHandler
 * Component placed in the application tree to manage the session timeout lifecycle.
 * Renders the warning modal when the user is inactive and handles renewal or auto-logout.
 */
const SessionTimeoutHandler = () => {
  const { isAuthenticated } = useSelector((state) => state.auth || {});

  const {
    isWarningOpen,
    countdown,
    effectiveWarningSeconds,
    isRefreshing,
    handleStayLoggedIn,
    handleLogoutNow,
  } = useSessionTimeout();

  if (!isAuthenticated) return null;

  return (
    <SessionTimeoutModal
      isOpen={isWarningOpen}
      countdown={countdown}
      totalWarningSeconds={effectiveWarningSeconds}
      isRefreshing={isRefreshing}
      onStayLoggedIn={handleStayLoggedIn}
      onLogoutNow={handleLogoutNow}
    />
  );
};

export default SessionTimeoutHandler;
